import saveEditorData from '../../Common/saveEditorData';
import notify from '../../Common/notify';
import axios from 'axios';

export default {
    namespaced: true,

    state() {
        return {
            id: 0,
            type: 0,
            name: '',
            helpText: '',
            helpTitle: '',
            helpModal: false,
            fields: [],
            expectedFields: [],
            loadedFields: [],
            complete: 0,
            completing: false,
            loaded: false,
        };
    },

    getters: {
        loadedFields(state) {
            return state.loadedFields;
        },

        expectedFields(state) {
            let ids = [];

            state.fields.forEach(field => {
                ids.push(field.id);
            });

            return ids;
        }
    },

    mutations: {
        setId(state, value) {
            state.id = value;
        },

        addLoadedField(state, value) {
            state.loadedFields.push(value);
        },

        setCompleting(state, value) {
            state.completing = value;
        },

        setType(state, value) {
            state.type = value;
        },

        setFields(state, value) {
            state.fields = value;
        },

        setName(state, value) {
            state.name = value;
        },

        setHelpTitle(state, value) {
            state.helpTitle = value;
        },

        setHelpText(state, value) {
            state.helpText = value;
        },

        toggleHelpModal(state, value) {
            state.helpModal = value;
        },

        setComplete(state, value) {
            state.complete = value;
        },

        setLoaded(state, value) {
            state.loaded = value;
        }
    },

    actions: {
        getData({ commit, state }, value) {
            return new Promise((resolve, reject) => {
                commit('overlay/toggle', true, { root: true });
                commit('setId', value);

                axios.get('/api/site/card/' + state.id)

                    // Success
                    .then((response) => {
                        const card = response.data;
                        commit('setType', card.type);
                        commit('setName', card.name);
                        commit('setHelpText', card.help_text);
                        commit('setHelpTitle', card.help_title);
                        commit('setFields', card.field);
                        commit('setComplete', card.completion ? card.completion.complete : 0);
                        commit('overlay/toggle', false, { root: true });
                        resolve();
                    })

                    // If there's an error here, the item doesn't exist.
                    .catch((error) => {
                        // Show an error message.
                        notify(error.response.data.message, 'error');
                        reject();
                    });
            });
        },

        saveData({ getters, commit }) {
            saveEditorData('site', getters.route, getters.postData)
                .then(() => {
                    commit('overlay/toggle', false, { root: true });
                })
                .catch(() => {});
        },

        setComplete({state, commit, dispatch}, value) {
            commit('setCompleting', true);
            if (value && value === 'true' || value === 'false') {
                const set = (value === 'true');
                commit('setComplete', set);
            } else {
                commit('setComplete', !state.complete);
            }

            dispatch('saveComplete')
                .then(() => {
                    commit('setCompleting', false);
                })
                .catch(() => {
                    commit('setCompleting', false);
                });
        },

        saveComplete({ state, dispatch }) {
            return new Promise((resolve, reject) => {
                axios.post('/api/site/card/complete', {
                    cardId: state.id,
                    complete: state.complete
                })
                    .then(() => {
                        dispatch('sidebar/getSidebar', '', { root: true })
                            .then(() => {
                                resolve();
                            })
                            .catch(() => {
                                reject();
                            });
                    })
                    .catch(() => {
                        reject();
                    });
            });
        }
    },
};
